(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/actionbar.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/actionbar.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
function getXpertenSize(xpertCost, rowPrice) {
  return parseInt(xpertCost / parseInt(rowPrice, 10), 10);
}
function canGenerateXpert(xpert, rowPrice, coupon) {
  rowPrice = parseInt(rowPrice, 10);
  xpert = getXpertenSize(xpert, rowPrice);
  let filteredXpert = svs.challenge.constants.XPERTEN[rowPrice].filter(xperten => xperten.size === xpert);
  if (filteredXpert.length > 0) {
    filteredXpert = filteredXpert[0];
    coupon.fullHedges = coupon.fullHedges || 0;
    coupon.halfHedges = coupon.halfHedges || 0;
    return !(filteredXpert.full < coupon.fullHedges || filteredXpert.half < coupon.halfHedges);
  }
  return false;
}
class Actionbar extends React.Component {
  componentDidMount() {
    const _this$props = this.props,
      hasActionbar = _this$props.hasActionbar,
      currentCoupon = _this$props.currentCoupon;
    if (hasActionbar || currentCoupon.xperten.isEditingBaseRow) {
      this.refreshActionbar();
    } else {
      svs.sport.actionbar.hide();
    }
  }
  componentDidUpdate() {
    const _this$props2 = this.props,
      hasActionbar = _this$props2.hasActionbar,
      currentCoupon = _this$props2.currentCoupon;
    if (hasActionbar || currentCoupon.xperten.isEditingBaseRow) {
      this.refreshActionbar();
      svs.sport.actionbar.reposition();
    } else {
      svs.sport.actionbar.hide();
    }
  }
  componentWillUnmount() {
    svs.sport.actionbar.hide();
  }
  get generateXpertText() {
    const _this$props3 = this.props,
      isCouponEmpty = _this$props3.isCouponEmpty,
      selectedXpert = _this$props3.selectedXpert,
      draw = _this$props3.draw,
      currentCoupon = _this$props3.currentCoupon;
    if (isCouponEmpty || canGenerateXpert(selectedXpert, draw.rowPrice, currentCoupon)) {
      return 'Gör minst en markering';
    }
    return 'Du har gjort för många hel- eller halvgarderingar';
  }
  refreshActionbar() {
    const _this$props4 = this.props,
      drawNumber = _this$props4.drawNumber,
      currentCoupon = _this$props4.currentCoupon,
      isCouponEmpty = _this$props4.isCouponEmpty,
      selectedXpert = _this$props4.selectedXpert,
      generateXpert = _this$props4.generateXpert,
      clearCoupon = _this$props4.clearCoupon,
      closeActionbar = _this$props4.closeActionbar,
      draw = _this$props4.draw;
    let actionbarOptions = null;
    if (currentCoupon.xperten.isEditingBaseRow) {
      actionbarOptions = {};
      actionbarOptions.leftButton = {
        text: this.generateXpertText,
        type: 'text',
        visible: true
      };
      actionbarOptions.centerButton = null;
      actionbarOptions.rightButton = {
        callback: () => {
          generateXpert(drawNumber, selectedXpert, true);
        },
        disabled: isCouponEmpty || !canGenerateXpert(selectedXpert, draw.rowPrice, currentCoupon),
        text: 'Generera system',
        type: 'button',
        visible: true
      };
      actionbarOptions.closeButton = {
        callback: () => {
          closeActionbar(drawNumber);
        },
        icon: 'icon-default icon-refresh',
        text: '',
        type: 'link',
        visible: true
      };
    } else if (selectedXpert) {
      actionbarOptions = {};
      actionbarOptions.leftButton = {
        text: "PIX! ".concat(getXpertenSize(selectedXpert, draw.rowPrice), " rader"),
        type: 'text',
        visible: true
      };
      actionbarOptions.centerButton = {
        callback: () => {
          generateXpert(drawNumber, selectedXpert, true);
        },
        icon: 'icon-default icon-300 icon-refresh',
        text: '',
        type: 'button',
        visible: true
      };
      actionbarOptions.rightButton = {
        callback: () => {
          clearCoupon(drawNumber);
        },
        icon: 'icon-default icon-300 icon-dustbin',
        text: '',
        type: 'link',
        visible: true
      };
    }
    if (actionbarOptions) {
      svs.sport.actionbar.show(actionbarOptions, this);
    } else {
      svs.sport.actionbar.hide();
    }
  }
  render() {
    return React.createElement("div", {
      className: "actionbar-content",
      id: "actionbar-content"
    });
  }
}
const _svs$challenge = svs.challenge,
  selectors = _svs$challenge.selectors,
  helpers = _svs$challenge.helpers;
const mapStateToProps = (state, ownProps) => {
  const drawNumber = Number(ownProps.match.params.drawNumber);
  return {
    draw: helpers.getDrawByDrawNumber(drawNumber, state),
    drawNumber,
    isCouponEmpty: selectors.isCouponEmpty(state, drawNumber)
  };
};
const _svs$challenge$action = svs.challenge.actions,
  clearCoupon = _svs$challenge$action.clearCoupon,
  closeActionbar = _svs$challenge$action.closeActionbar,
  generateXpert = _svs$challenge$action.generateXpert;
svs.challenge.Actionbar = withRouter(ReactRedux.connect(mapStateToProps, {
  clearCoupon,
  closeActionbar,
  generateXpert
})(Actionbar));

 })(window);